export default function px(value) {
    let number = Number(value);

    if (value.includes('rem')) {
        number = Number(value.trim().slice(0, value.indexOf('rem')));
    }

    if (Number.isNaN(number)) {
        return value;
    }

    return `${ number * 16 }px`;
}
